<div class="atn-app-general-tab">
  <div class="atn-app-general-tab__details">
    <atn-ds-iconpicker
      label="Icon"
      [value]="appIconSg()"
      (valueChange)="updateAppPropertyHandler('icon', $event ?? '')"
      data-test-id="icon-label"
    />
    <atn-ds-text
      label="Name"
      placeholder="Enter a name"
      [value]="appNameSg()"
      (change)="updateAppPropertyHandler('name', $event ?? '')"
      data-test-id="name-label"
    ></atn-ds-text>
    <atn-ds-text
      label="Alias"
      placeholder="Enter an alias"
      [value]="appAliasSg()"
      (change)="updateAppPropertyHandler('alias', $event ?? '')"
      data-test-id="alias-label"
    ></atn-ds-text>
    <atn-ds-text
      label="Description"
      placeholder="Enter a description"
      [value]="appDescriptionSg()"
      (change)="updateAppPropertyHandler('description', $event)"
      data-test-id="description-label"
    ></atn-ds-text>
  </div>
</div>
